import {mapState} from "vuex";

export default {
	computed: {
		...mapState("authStore", [
			"sessionExpiresSeconds",
		]),
	},

	watch: {
		sessionExpiresSeconds: {
			handler(value) {
				if (value !== 120) {
					return;
				}
				this.$vmodal.replace({
					component: () => import("@/components/modals/AutoLogout.vue"),
					isDismisable: false,
				});
			},
		},
	},
};
